module.exports = __webpack_public_path__ + "static/media/litho-6.ff1a352d.jpg";